module.exports = {
	"_args": [
		[
			"babylon@https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "babylon@>=5.8.22 <6.0.0",
	"_id": "babylon@5.8.35",
	"_inCache": true,
	"_location": "/babylon",
	"_phantomChildren": {},
	"_requested": {
		"name": "babylon",
		"raw": "babylon@https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
		"rawSpec": "https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/",
		"/babel-core"
	],
	"_resolved": "https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
	"_shasum": "34fbc3155b228b0b6780d0623ac4ff32a97647c4",
	"_shrinkwrap": null,
	"_spec": "babylon@https://registry.npmjs.org/babylon/-/babylon-5.8.35.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "sebmck@gmail.com",
		"name": "Sebastian McKenzie"
	},
	"bugs": {
		"url": "https://github.com/babel/babel/issues"
	},
	"contributors": [
		{
			"name": "keeyipchan"
		},
		{
			"name": "List of Acorn contributors. Updated before every release."
		},
		{
			"name": "Alistair Braidwood"
		},
		{
			"name": "Andres Suarez"
		},
		{
			"name": "Aparajita Fishman"
		},
		{
			"name": "Arian Stolwijk"
		},
		{
			"name": "Artem Govorov"
		},
		{
			"name": "Brandon Mills"
		},
		{
			"name": "Charles Hughes"
		},
		{
			"name": "Conrad Irwin"
		},
		{
			"name": "David Bonnet"
		},
		{
			"name": "Forbes Lindesay"
		},
		{
			"name": "Gilad Peleg"
		},
		{
			"name": "impinball"
		},
		{
			"name": "Ingvar Stepanyan"
		},
		{
			"name": "Jesse McCarthy"
		},
		{
			"name": "Jiaxing Wang"
		},
		{
			"name": "Joel Kemp"
		},
		{
			"name": "Johannes Herr"
		},
		{
			"name": "Jürg Lehni"
		},
		{
			"name": "Adrian Rakovsky"
		},
		{
			"name": "Kevin Kwok"
		},
		{
			"name": "krator"
		},
		{
			"name": "Marijn Haverbeke"
		},
		{
			"name": "Martin Carlberg"
		},
		{
			"name": "Mathias Bynens"
		},
		{
			"name": "Mathieu 'p01' Henri"
		},
		{
			"name": "Max Schaefer"
		},
		{
			"name": "Max Zerzouri"
		},
		{
			"name": "Mihai Bazon"
		},
		{
			"name": "Mike Rennie"
		},
		{
			"name": "Nick Fitzgerald"
		},
		{
			"name": "Oskar Schöldström"
		},
		{
			"name": "Paul Harper"
		},
		{
			"name": "Peter Rust"
		},
		{
			"name": "PlNG"
		},
		{
			"name": "r-e-d"
		},
		{
			"name": "Rich Harris"
		},
		{
			"name": "Sebastian McKenzie"
		},
		{
			"name": "zsjforcn"
		}
	],
	"dependencies": {},
	"description": "<p align=\"center\">   <img alt=\"babylon\" src=\"https://raw.githubusercontent.com/babel/logo/master/babylon.png\" width=\"700\"> </p>",
	"devDependencies": {},
	"homepage": "https://babeljs.io/",
	"license": "MIT",
	"main": "lib/index.js",
	"name": "babylon",
	"optionalDependencies": {},
	"readme": "<p align=\"center\">\n  <img alt=\"babylon\" src=\"https://raw.githubusercontent.com/babel/logo/master/babylon.png\" width=\"700\">\n</p>\n\n<p align=\"center\">\n  Babylon is a JavaScript parser used in <a href=\"https://github.com/babel/babel\">Babel</a>.\n</p>\n\n## Credits\n\nHeavily based on [acorn](https://github.com/marijnh/acorn) and [acorn-jsx](https://github.com/RReverser/acorn-jsx),\nthanks to the awesome work of [@RReverser](https://github.com/RReverser) and [@marijnh](https://github.com/marijnh).\n\nSignificant diversions are expected to occur in the future such as streaming, EBNF definitions, sweet.js integration,\ninterspacial parsing, comment attachment and more.\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/babel/babel.git"
	},
	"version": "5.8.35"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babylon/package.json
 ** module id = ./node_modules/babylon/package.json
 ** module chunks = 0
 **/